import { useBusinessServiceRequest } from '@ingenico/react-section-utils';
import { useCallback, useMemo } from 'react';
import { getDeviceLogsFilters } from '../components/device-logs-modal/DeviceLogsModal.util';
import { DeviceManagementService } from '../domain/business/services/deviceManagement.service';

export function useShouldShowViewLogs({ logicalDeviceId }: { readonly logicalDeviceId: string }): boolean {
  // ============= request call ===============
  const searchDeviceLogsQuery = useBusinessServiceRequest(
    DeviceManagementService,
    useCallback(
      (service) =>
        logicalDeviceId.length > 0
          ? service.searchDeviceLogs({
              logicalDeviceId,
              body: { filters: getDeviceLogsFilters(), sort: {} },
              params: { limit: 1 },
            })
          : null,
      [logicalDeviceId],
    ),
  );

  // ==========================================

  return useMemo(() => {
    return searchDeviceLogsQuery.isLoading ? false : !!searchDeviceLogsQuery?.data?.data?.length;
  }, [searchDeviceLogsQuery]);
}
